<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách cấu hình Giá gói dịch vụ/Thiết bị</h1>
      <div class="btn-group float-right sm-float-none">
        <button class="f12 font-medium btn btn-outline-secondary" @click="addConfig()">
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>

        <!-- <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="exportReceipts()"
        >
         <i class="bx bx-download"></i> Xuất file
        </button> -->
      </div>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              placeholder="Thời gian"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center pt-1"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 pt-1 time-placeholder"> Thời gian tạo </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.codeService"
              :options="dataConfigService"
              placeholder="Dịch vụ"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.customerType"
              :options="dataContractType"
              placeholder="Loại hợp đồng"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.status" :options="listState" placeholder="Trạng thái" />
          </div>

          <div class="form-group form-group-action">
            <button @click="submitForm" class="btn btn-primary hc-37 mr-2 pt-2">
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>

            <b-dropdown
              size="sm"
              text="Chọn hoạt động"
              variant="outline-light"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              v-if="selectedItems.length"
            >
              <button type="button" class="dropdown-item" @click="actionAfterChooseItem('LOCK')">
                <i class="bx bx-lock-alt"></i><span>&nbsp;</span> Khoá
              </button>
              <button type="button" class="dropdown-item" @click="actionAfterChooseItem('ACTIVE')">
                <i class="bx bx-lock-open"></i><span>&nbsp;</span> Mở khoá
              </button>
            </b-dropdown>
          </div>
        </form>
      </div>
      <div class="card-body" v-if="dataPermission && dataPermission.includes('SCON_RECEIPT_VIEW')">
        <div class="tab-content" id="nav-tabContent">
          <div class="table-responsive table-responsive-sm" style="min-height: 20rem">
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr class="text-center">
                  <th scope="col">
                    <div class="checkbox text-center">
                      <b-form-checkbox class="text-center" v-model="selectAll"></b-form-checkbox>
                    </div>
                  </th>
                  <th scope="col">Tên gói/Thiết bị</th>
                  <th scope="col">Đơn giá</th>
                  <th scope="col">Dịch vụ áp dụng</th>
                  <th scope="col">Loại HĐ áp dụng</th>
                  <th scope="col">Mô tả</th>
                  <th scope="col">Trạng thái</th>
                  <th scope="col">Thời gian</th>
                  <th scope="col">Người tạo</th>
                  <th scope="col">Thao tác</th>
                </tr>
              </thead>

              <tbody v-if="loading">
                <tr>
                  <td colspan="12" align="center">
                    <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                  </td>
                </tr>
              </tbody>

              <tbody v-else>
                <tr
                  class="table-row text-center"
                  v-for="(item, index) in dataListConfig"
                  :key="index"
                >
                  <td>
                    <!-- {{ search.limit * (search.page - 1) + index + 1 }} -->
                    <b-form-checkbox
                      class="text-center"
                      v-model="selectedItems"
                      :value="item.id"
                      :unchecked-value="item.id"
                      @change="checkSelectedItem(item.id)"
                    ></b-form-checkbox>
                  </td>

                  <td>
                    {{ item.name ? item.name : '' }}
                  </td>

                  <td class="col-2">{{ item.amount ? item.amount : 0 | transformMoney }} VNĐ</td>

                  <td>
                    {{ item.nameService ? item.nameService : '' }}
                  </td>

                  <td class="col-2">
                    {{ item.nameGroup ? item.nameGroup : '' }}
                  </td>

                  <td>
                    {{ item.description ? item.description : '' }}
                  </td>

                  <td>
                    <span class="badge" v-bind:class="[item.status ? item.status : '']">
                      {{ item.status | mapTextStatus(listState) }}
                    </span>
                  </td>

                  <td>
                    <p class="text-nowrap" v-show="item.dateCreate">
                      Tạo: {{ item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                    </p>
                    <p class="text-nowrap" v-show="item.dateEdit">
                      Cập nhật: {{ item.dateEdit | formatDate('HH:mm, DD/MM/YYYY') }}
                    </p>
                  </td>

                  <td>
                    <p class="text-nowrap text-center">
                      {{ item.createdByInfo ? item.createdByInfo.name : '' }}
                    </p>
                    <p class="text-nowrap text-center">
                      {{ item.createdByInfo ? item.createdByInfo.email : '' }}
                    </p>
                  </td>

                  <td class="text-center">
                    <b-dropdown class="text-center" variant="outline-light">
                      <button class="dropdown-item" @click="editConfig(item)">
                        <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
                      </button>
                      <button
                        class="dropdown-item"
                        @click="actionLockConfig(item, 'LOCK')"
                        v-show="item.status === 'ACTIVE'"
                      >
                        <i class="bx bx-lock-alt"></i><span>&nbsp;</span>Khoá
                      </button>
                      <button
                        class="dropdown-item"
                        @click="actionLockConfig(item, 'ACTIVE')"
                        v-show="item.status === 'LOCK'"
                      >
                        <i class="bx bx-lock-open"></i><span>&nbsp;</span>Mở khoá
                      </button>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>

    <NotiSuccess
      :showModalSuccess="showModalSuccess"
      :messSuccess="messNoti"
      @close="showModalSuccess = false"
    >
    </NotiSuccess>

    <NotiError :showModalErr="showModalErr" :messErr="messNoti" @close="showModalErr = false">
    </NotiError>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import { ConfigService } from '@/services/config-price.service'
  import { CommonService } from '@/services/common.service'

  import Config from '@/thirdParty/config'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import moment from 'moment'
  import { SalesManagerService } from '@/services/sales-manager.service'

  export default {
    data() {
      return {
        loading: true,
        selectedItems: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        listAfterSale: Config.listAfterSale,
        dataListConfig: [],
        listUser: [],
        listState: [
          { id: 'all', text: 'Tất cả' },
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'ACTIVE', text: 'Đang áp dụng' },
          { id: 'LOCK', text: 'Đã khoá' },
        ],
        dataConfigRegion: [],
        dataContractType: Config.listContractType,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataConfigService: [],
        localeData: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Áp dụng',
          cancelLabel: 'Hủy bỏ',
          weekLabel: 'W',
          daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
          monthNames: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12',
          ],
          firstDay: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        stateSelected: '',
        notiModal: false,
        cancelItem: {},
        showModalSuccess: false,
        showModalErr: false,
        messNoti: '',
        showLoading: false,
        checkSelectAll: false,
      }
    },

    mixins: [prepareQueryParamsMixin],

    filters: {
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
      transformMoney(data) {
        return data ? data.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : ''
      },
    },

    created() {
      this.fetchData()
      this.getListStaffBySuperior()
      this.configSystem()
    },

    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
      selectAll: {
        get: function () {
          return this.dataListConfig
            ? this.selectedItems.length === this.dataListConfig.length
            : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataListConfig.forEach(item => {
              selected.push(item.id)
            })
            this.checkSelectAll = true
          }
          this.selectedItems = selected
        },
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },

    methods: {
      // chuyển trang chi tiết
      editConfig(item) {
        this.$router.push({ path: `/edit-device-service-price-config/${item.id}` })
      },

      addConfig() {
        this.$router.push('/add-device-service-price-config')
      },

      // dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true

          for (const key in this.search) {
            if (this.search[key] === 'all') delete this.search[key]
          }

          // this.search.codeGroup = 'SELL'

          const data = await ConfigService.getListConfig(this.search)
          if (data.code === 1000) {
            this.dataListConfig = data.data
            this.pagination.total = data.totalPage.total ? data.totalPage.total : 0
          } else {
            this.dataListConfig = []
            this.pagination.total = 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // nút lọc
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()

        this.$store.commit('search/SET_DATA_SEARCH_OTHER', {
          data: this.search,
          router: this.$router.currentRoute.path,
        })
      },
      // nút bỏ lọc
      async clearSearch() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRange1 = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },

      async exportReceipts() {
        try {
          this.loading = true

          for (const key in this.search) {
            if (this.search[key] === 'all') delete this.search[key]
          }

          await ConfigService.exportReceipts(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.listUser.push({ id: 'all', text: 'Tất cả' })
            data.data.map(e => this.listUser.push({ id: e.userId, text: e.name }))
            return
          }
          this.listUser = []
        } catch (error) {
          console.log(error)
        }
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataConfigService.push({ id: 'all', text: 'Tất cả' })
              data.data.services.map(e => this.dataConfigService.push({ id: e.code, text: e.name }))
              this.getListService()
            }
          })
          .catch(error => console.log(error))
      },
      async getListService() {
        try {
          const response = await SalesManagerService.getGroupService({})
          if (response.code === 1000) {
            this.dataGroupService = response.data.groupService
            const data = this.dataGroupService.filter(e => e.service === 'SELL')
            if (data[0].detail.length > 0) {
              data[0].detail.map(e => {
                const body = {
                  id: e.code,
                  text: this.serviceTypes(e.name),
                }
                this.dataConfigService.push(body)
              })
            }
          }
        } catch (error) {
          console.log(error, '=========>')
        }
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },

      actionAfterChooseItem(status) {
        const statusCheck = []
        this.dataListConfig.map(item => {
          this.selectedItems.map(id => {
            if (item.id === id) statusCheck.push(item.status)
          })
        })

        if (statusCheck.includes('ACTIVE') && statusCheck.includes('LOCK')) {
          this.showModalErr = true
          this.messNoti = 'Vui lòng chọn các bản ghi cùng trạng thái'
          return
        }

        this.actionLockConfig(this.selectedItems, status)
      },

      async actionLockConfig(items, status) {
        try {
          this.showLoading = true
          const response = await ConfigService.actionLockConfig({
            listId: Array.isArray(items) ? items : [items.id],
            actionStatus: status,
          })
          if (response.code === 1000) {
            this.showModalSuccess = true
            this.messNoti = `${status === 'ACTIVE' ? 'Mở khoá' : 'Khoá'} gói dịch vụ/Thiết bị thành công`
            this.selectedItems = []
            await this.fetchData()
          } else {
            this.showModalErr = true
            this.messNoti = response.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      checkSelectedItem(id) {
        if (this.checkSelectAll && this.selectedItems.length === 0) {
          const selected = []
          this.dataListConfig.forEach(item => {
            if (item.id !== id) selected.push(item.id)
          })
          this.selectedItems = selected
        }
        if (this.selectedItems.length !== 0) this.checkSelectAll = false
      },

      transformDate() {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },

      getDataSearch() {
        if (JSON.stringify(this.dataSearch) === '{}') {
          this.search = {
            limit: 20,
            page: 1,
          }
        } else {
          this.search = this.dataSearch
          this.dateRange.startDate = this.search.startDate
            ? new Date(this.search.startDate).toString()
            : null
          this.dateRange.endDate = this.search.endDate
            ? new Date(this.search.endDate).toString()
            : null
          if (this.search.regionId) this.queryProvince(this.search.regionId)
          this.fetchData()
        }
      },
    },
  }
</script>

<style scoped>
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }
  .LOCK {
    color: #fff;
    background-color: #dc3545;
  }
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }
</style>

<style>
  /*  */
  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px;
  }
</style>
